import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { GenericFallbacksWrapper } from '../../../components/Fallback/GenericFallbacksWrapper';
import { RubricConfig } from '../../../schemas/Rubric.schema';
import { rubricConfigAtom } from '../../../services/state/RubricsStateJ';
import { NoRubricsMessage } from './NoRubricsMessage';
import { RubricConfigConfirmDelete } from './RubricConfigConfirmDelete';
import { RubricConfigFormModal } from './RubricConfigFormModal';
import { RubricConfigGrid } from './RubricConfigGrid';
import { useRubricConfigFormData } from './useRubricConfigFormData';

export function RubricsConfigLoader() {
  const configs = useAtomValue(rubricConfigAtom);
  if (!configs) {
    return null;
  }
  return <RubricsConfig data={configs} />;
}

interface IRubricConfigProps {
  data: RubricConfig[];
}
export function RubricsConfig({ data }: IRubricConfigProps) {
  return (
    <>
      <RubricConfigFormModal />
      <RubricConfigConfirmDelete />
      <Box width='100%' padding='8px 12px 12px'>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} mb={'1rem'}>
          <Typography variant='h4'>Rubrics</Typography>
          {data.length > 0 && <CreateRubricConfig />}
        </Stack>
        <Stack>
          {data.length === 0 ? (
            <NoRubricsMessage />
          ) : (
            <GenericFallbacksWrapper>
              <RubricConfigGrid data={data} />
            </GenericFallbacksWrapper>
          )}
        </Stack>
      </Box>
    </>
  );
}

export function CreateRubricConfig() {
  const { setSelectedAction } = useRubricConfigFormData();
  const handleClick = useCallback(() => {
    setSelectedAction('create');
  }, [setSelectedAction]);
  return (
    <Button
      variant={'contained'}
      color={'secondary'}
      startIcon={<AddIcon />}
      size={'large'}
      onClick={handleClick}
    >
      Create Rubric
    </Button>
  );
}
